// extracted by mini-css-extract-plugin
export default {"tab-button":"tab-button_tab-button__YHOEg","tab-button--clicked":"tab-button_tab-button--clicked__dEPHi"};